import ChartDialogEditor from 'scoreboard/charts/edit/chart-dialog-editor'
import { setNewIdsOnChartDesigner } from 'scoreboard/charts/edit/charts-edit'
import $ from 'jquery'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import appDisplay from 'scoreboard/components/app-display'
import globals from 'scoreboard/components/globals'

/** @override */
const ScorecardChartDialogEditor = ChartDialogEditor.extend({

	/**
	 * @type {{
	 *   scorecardNodeId: number
	 * }}
	 */
	options: null,

	initialize: function (options = {}) {
		options.chartDesignerEditorOptions = options.chartDesignerEditorOptions || {}
		options.chartDesignerEditorOptions.hideTableToggle = true
		options.submitLabel = 'common.save'
		options.submitSecondary = this.submitSecondary.bind(this)
		ChartDialogEditor.prototype.initialize.apply(this, arguments)
	},

	render: function() {
		ChartDialogEditor.prototype.render.apply(this, arguments)
		// display the 'Reset to Defaults' button
		this.$('.reset').removeClass('is-not-displayed')
	},

	submit: function() {
		let isNew = this.model.isNew()
		const url = `api/scorecards/${this.options.scorecardNodeId}/chart`
		$.ajax(url, {
			method: isNew ? 'POST' : 'PATCH',
			data: JSON.stringify(this.model.toPostJSON()),
			success: response => {
				setNewIdsOnChartDesigner(this.model, response)
				this.trigger('save', {
					chartDesigner: this.model,
					chartData: this.model.data
				})
				this.trigger('done')
			}
		})
	},

	/**
	 * #59778 Resets the chart to its defaults
	 * Called when the secondary button ('Reset to Defaults') is clicked
	 * Confirm prompt is displayed to confirm the reset before it is executed
	 */
	submitSecondary: function () {
		const prompt = new ConfirmPrompt({
			titleKey: 'charts.chart.reset.defaults',
			messageKey: 'charts.chart.reset.defaults.confirm',
			confirmLabel: 'common.reset',
			cancelLabel: 'common.cancel',
			onConfirm: () => {
				const calendarPeriodId = globals.periodId
				const url = `api/scorecards/${this.options.scorecardNodeId}/chart/reset?calendarPeriodId=${calendarPeriodId}`
				$.ajax(url, {
					method: 'POST',
					success: (model) => {
						this.trigger('reset', {
							chartDesigner: model.chartDesigner,
							chartData: model.chartData
						})
						this.trigger('done')
					},
					error: (xhr) => {
						this.formView.error(xhr)
					}
				})
			}
		})
		prompt.on('cancel', () => {
			this.formView.resetForm()
			this.formView.change()
		})
		appDisplay.dialog(prompt)
	}
})

export default ScorecardChartDialogEditor
ScorecardChartDialogEditor.__filename__ = 'charts/edit/scorecard-chart-dialog-editor.js'
